export default "__VITE_ASSET__BbsGYx8U__"